// @flow

import {
  APPLY_SYSTEM_GENERATED_DISCOUNTS_CONFIG,
  APPLY_SYSTEM_GENERATED_GLOBAL_DISCOUNTS_CONFIG,
} from '../components/common/vbd/constants';
import { APPLY_SYSTEM_GENERATED_CNBC_CONFIG } from '../components/common/sgcnbc/constants';
import { CHECKBOX_INPUT_TYPE } from '../formik-utils/consts';
import {
  ESTIMATE_CUSTOMER_VIEW_ENABLED_BACKEND_NAME,
  IS_ADVANCED_SECURITY_LIVE_IN_CE1,
  IS_ECKU_CFU_PACKAGES_LIVE_IN_CE1,
} from '../constants';
import { COMMITTED_CAPACITY_JSON_CONFIG } from '../components/committed-capacity/config';

import { ADVANCED_SECURITY_CUSTOM_DISCOUNTS_JSON_CONFIG } from './advanced-security';
import { CUSTOM_DISCOUNTS_JSON_CONFIG } from './custom-discounts';
import { CREDITS_AND_BURSTS_JSON_CONFIG } from './credits-and-bursts';
import { ESTIMATE_ACCOUNT_DETAILS_CONFIG } from './estimate-account-details';
import { ESTIMATE_COMMIT_DETAILS_CONFIG } from './estimate-commit-details';
import { TCO_INPUTS_JSON_CONFIG } from './tco-estimate-inputs';

export const ESTIMATE_TOP_LEVEL_CONFIG = [
  ...ESTIMATE_ACCOUNT_DETAILS_CONFIG,
  ...ESTIMATE_COMMIT_DETAILS_CONFIG,
  CUSTOM_DISCOUNTS_JSON_CONFIG,
  APPLY_SYSTEM_GENERATED_DISCOUNTS_CONFIG,
  APPLY_SYSTEM_GENERATED_GLOBAL_DISCOUNTS_CONFIG,
  CREDITS_AND_BURSTS_JSON_CONFIG,
  ...(IS_ECKU_CFU_PACKAGES_LIVE_IN_CE1 ? [COMMITTED_CAPACITY_JSON_CONFIG] : []),
  APPLY_SYSTEM_GENERATED_CNBC_CONFIG,
  TCO_INPUTS_JSON_CONFIG,
  ...(IS_ADVANCED_SECURITY_LIVE_IN_CE1 ? [ADVANCED_SECURITY_CUSTOM_DISCOUNTS_JSON_CONFIG] : []),
  {
    displayName: ESTIMATE_CUSTOMER_VIEW_ENABLED_BACKEND_NAME,
    backendFieldName: ESTIMATE_CUSTOMER_VIEW_ENABLED_BACKEND_NAME,
    inputType: CHECKBOX_INPUT_TYPE,
  },
];
